import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=2202eb82&"
import script from "./Checkbox.vue?vue&type=script&lang=js&"
export * from "./Checkbox.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/themes/default/form.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/styles/themes/default/checkbox.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports